export default __webpack_public_path__ + "static/media/demo-recorder-strip.5a8a25f1.png";